///Config file for tagular events////

(function($) {
    var $submitReview = $( '.js-submit-review' );
    var analytics = {
        // ELEMENTs
        '[data-tagular-tag="elementClicked"]': {
            '@type': 'ElementClicked',
            webElement: {
                elementType: 'data.tagulartype',
                location: 'data.tagularlocation',
                position: 'data.tagularposition',
                text: 'data.tagulartext'
            },
            actionOutcome: 'data.tagularoutcome'
        },
        // FORMS
        '[data-tagular-tag="formInput"]': {
            '@type': 'FieldInputted',
            userInputField: {
                fieldType: 'data.tagularfieldtype',
                fieldId: 'data.tagularfieldnum',
                fieldName: 'data.tagularname',
                fieldValue: 'this.value',
                fieldLabel: 'this.name'
            },
            formContext: {
                formType: 'data.tagularformtype',
                formName: 'data.tagularformname',
                formId: 'data.tagularformid'
            }
        },
        '[data-tagular-tag="formSelect"]': {
            '@type': 'FieldSelected',
            userInputField: {
                fieldType: 'data.tagularfieldtype',
                fieldId: 'data.tagularfieldnum',
                fieldName: 'data.tagularname',
                fieldValue: 'this.value',
                fieldLabel: 'this.name'
            },
            formContext: {
                formType: 'data.tagularformtype',
                formName: 'data.tagularformname',
                formId: 'data.tagularformid'
            }
        }
    }; //analytics

    _Beam.load(analytics);

    var mutationObserver = window.MutationObserver || window.WebKitMutationObserver;

    var observer = new mutationObserver(function() {
		_Beam.load(analytics);
    });

    observer.observe(document, {
        subtree: true,
        attributes: true
	});

	$submitReview.click( function ( e ) {
        tagular( 'beam', 'ElementClicked', {
            '@type': 'redventures.usertracking.v3.ElementClicked',
            webElement: {
                elementType: 'data.tagulartype',
                location: $( this ).data( 'tagularlocation' ),
                position: $( this ).data( 'tagularposition' ),
                text: 'data.tagulartext'
            },
            actionOutcome: 'data.tagularoutcome'
        } );
    } );
})(jQuery);



// WEBPACK FOOTER //
// ./assets/js/tagular.js